import React, {useState, useMemo, useEffect } from "react";
import GridLayout from "./Layouts/Grid";
import CarouselLayout from "./Layouts/Carousel";
import "./BlogArticlesList.scss";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { BlogArticlesHeader } from "./BlogArticlesHeader/BlogArticlesHeader";
import { decodeHtmlEntities } from "frontend/js/helpers";
import shopify from '../../../../js/shopify';

const layouts = {
    "grid": GridLayout,
    "grid_reverse": GridLayout,
    "carousel": CarouselLayout
};

export const BlogArticlesList = ({ initialArticles, settings }) => {
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    let Layout = layouts[settings.section.layout_type] || GridLayout;
    const [query, setQuery] = useState("");
        const [tag, setTag] = useState(() => {
        if (typeof window !== "undefined") {
            const url = new URL(window.location.href);
            return url.searchParams.get("tag") || "";
        }
        return "";
    });
    const [graphArticles, setGraphArticles] = useState([]);  
    const { blocks } = settings;


    if (isMobile) {
        Layout = layouts[settings.section.layout_type_mobile] || GridLayout;
    }

    useEffect(() => {  
        const fetchAllArticles = async () => {
            try {
                if (!settings?.blog?.handle) {
                    return;
                }
                const allArticles = await shopify.getAllBlogArticles(settings.blog.handle, tag);
 
                setGraphArticles(allArticles);
            } catch (error) {
                setGraphArticles([]);
            }
        }
        fetchAllArticles();

    }, [tag, settings.blog.handle]);


    const prepareContentForSearch = (content: string): string => {
        if (!content) return "";
        let decodedContent = decodeHtmlEntities(content);
        decodedContent = decodedContent.replace(/<br\s*\/?>/gi, " ");
        decodedContent = decodedContent.replace(/<[^>]*>/g, " ");
        return decodedContent.replace(/\s+/g, " ").toLowerCase();
    };

      
    let articles = initialArticles;

    if (settings.section.layout_type == 'carousel'){
        articles = [];
        if (blocks){
            blocks.forEach((block) => {
                if (block.article) {
                    articles.push(block.article);
                }
            });
        }
    }

    const filteredArticles = useMemo(() => {
        if (!query && !tag) return graphArticles;

        const searchTerms = query
            .toLowerCase()
            .split(/\s+/)
            .flatMap(term => term.split(':'))
            .map(term => term.trim())
            .filter(Boolean);

        return graphArticles.filter(article => {
            const matchesTag = tag
                ? Array.isArray(article.tags) && article.tags.includes(tag)
                : true;

            if (!query || searchTerms.length === 0) {
                return matchesTag;
            }

            const searchableTitle = article.title?.toLowerCase() || "";
            const searchableContent = prepareContentForSearch(article.content || "");

    
            const matchesQuery = searchTerms.every(term =>
                searchableTitle.includes(term) || searchableContent.includes(term)
            );

            return matchesQuery && matchesTag;
        });
    }, [graphArticles, query, tag]);


    const allTags = useMemo(() => {
        const tagSet = new Set();
        initialArticles && initialArticles.forEach(article => {
            if (Array.isArray(article.tags)) {
                article.tags.forEach(tag => tagSet.add(tag));
            }
        });
        return Array.from(tagSet);
    }, [initialArticles]);

    
    return (
        <div className="blog-articles flex flex-col">
           { settings.section.layout_type != 'carousel' && <BlogArticlesHeader
                initialArticles={filteredArticles}
                settings={settings}
                query={query}
                setQuery={setQuery}
                allTags={allTags}
                setTag={setTag}
                tag={tag}
            />  }
            <div
                className={`relative`}
                style={{
                    paddingTop: `${settings.section.padding_top}px`,
                    paddingBottom: `${settings.section.padding_bottom}px`,
                }}
            >
                <div className="relative w-full h-full justify-end items-end transition-opacity duration-500 ease-in-out">
                    <Layout initialArticles={settings.section.layout_type == 'carousel' ? articles : filteredArticles} settings={settings} key={tag}/>
                </div>
            </div>
        </div>
    );
};
